import { AbstractContentState, useCmsContent } from '@cp-shared-19/frontend-integration';
import { BundledProductContactRecord } from 'cpfr-common';
import { fetchBundledProductsContactInfo } from './BundledProductSlice';
import { BundledProductContentSelector } from './BundledProductContentSelector';

export function useBundledProduct(): AbstractContentState<BundledProductContactRecord[]> {
    return useCmsContent(fetchBundledProductsContactInfo, BundledProductContentSelector);
}
